import { RESOURCE_ORDER } from '../Game/definitions.js'

export default class EngineerView
{
    constructor(_options)
    {
        this.factory = _options.factory
        this.container = this.factory.createEngineer()
        this.container.position.set(0, 8, 0)
        this.container.rotation.z = Math.PI
        this.walkPhase = 0
        this.actionPhase = 0
        this.actionType = null
    }

    syncInventory(_inventory)
    {
        const anchor = this.container.userData.inventory
        for(const child of [...anchor.children])
        {
            child.traverse((_child) =>
            {
                if(_child.isMesh)
                    _child.geometry.dispose()
            })
            anchor.remove(child)
        }

        let index = 0
        for(const resource of RESOURCE_ORDER)
        {
            for(let count = 0; count < _inventory[resource]; count++)
            {
                const item = this.factory.createItem(resource, 0.82)
                item.position.set((index % 2 - 0.5) * 0.28, 0, Math.floor(index / 2) * 0.16)
                item.rotation.z = (index % 2 ? 1 : -1) * 0.12
                anchor.add(item)
                index++
            }
        }
    }

    update(_delta, _moving, _action)
    {
        const parts = this.container.userData
        this.walkPhase += _delta * (_moving ? 11 : 4)
        const walk = _moving ? Math.sin(this.walkPhase) : 0
        parts.legs[0].rotation.x = walk * 0.65
        parts.legs[1].rotation.x = - walk * 0.65
        parts.arms[0].rotation.x = - walk * 0.4
        parts.body.position.z = _moving ? Math.abs(Math.sin(this.walkPhase)) * 0.05 : 0
        parts.pickaxe.visible = _action?.type === 'mine'
        parts.axe.visible = _action?.type === 'chop'
        if(_action)
        {
            if(this.actionType !== _action.type)
            {
                this.actionType = _action.type
                this.actionPhase = 0
            }
            this.actionPhase = (this.actionPhase + _delta / 0.6) % 1
            const smooth = (_value) => _value * _value * (3 - 2 * _value)
            let swing = 0
            let impact = this.actionPhase < 0.18 ? 1 - smooth(this.actionPhase / 0.18) : 0
            if(this.actionPhase < 0.55)
                swing = -5.05 + 2.45 * smooth(this.actionPhase / 0.55)
            else if(this.actionPhase < 0.72)
                swing = -2.6 - 0.15 * smooth((this.actionPhase - 0.55) / 0.17)
            else
            {
                const progress = (this.actionPhase - 0.72) / 0.28
                swing = -2.75 - 2.3 * progress * progress
            }

            parts.arms[1].rotation.x = swing
            parts.arms[0].rotation.x = -0.3 - impact * 0.45
            parts.body.position.y = - impact * 0.09
            parts.head.rotation.x = impact * 0.14
        }
        else
        {
            this.actionType = null
            this.actionPhase = 0
            parts.arms[1].rotation.x = walk * 0.4
            parts.body.position.y = 0
            parts.head.rotation.x = 0
        }
    }
}
